import { render, staticRenderFns } from "./GroupRelatedIndex.vue?vue&type=template&id=6d90b1f7&scoped=true"
import script from "./GroupRelatedIndex.vue?vue&type=script&lang=js"
export * from "./GroupRelatedIndex.vue?vue&type=script&lang=js"
import style0 from "./GroupRelatedIndex.vue?vue&type=style&index=0&id=6d90b1f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d90b1f7",
  null
  
)

export default component.exports